export const LIST_A = [
    {
        q: '订单服务时长是多久？',
        a: '订单服务时长根据律师不同，服务项目不同，服务时长也有所不同；您可以在服务价格旁边查看，或在聊天窗口顶部服务项目旁边查看。',
    },
    {
        q: '服务怎么样才算结束？',
        a: '您购买的律师服务以律师接单开始服务为服务计算的起始点，服务时长结束或您主动发起服务结束为终点；如果您购买的是追问付费，则以追问次数用完为止。',
    },
    {
        q: '离开咨询如何查询到我的咨询内容？',
        a: '您可以在“咨询”菜单内或“我的”-->“我的订单”内寻找您的咨询内容。',
    },
    {
        q: '为什么没有律师接单？',
        a: '当前留言人数较多，为了律师更好的了解您的问题，可能会存在律师接单时间较长的情况，请您耐心等待。',
    },
    {
        q: '律师说两句话就不回了怎么办？',
        a: '您可以在服务内点击“提醒一下”功能；也可以在“我的”客服中心内拨打人工电话，催促律师；律师在平台为兼职服务，可能存在服务不及时的情况，律师看到后会第一时间回复。',
    },
]

export const LIST_B = [
    {
        q: '我该怎么起诉，需要准备什么材料？',
        a: '起诉需要准备起诉状，双方当事人身份信息，证据材料，证据目录，到管辖地的法院进行材料递交。'
    },
    {
        q: '起诉案件的时效性是多久？',
        a: '每个案件类型的时效性不一样，一般的民事案件的时效是三年，劳动纠纷的时效是一年。'
    },
    {
        q: '多少钱到立案的标准？我该怎么做？',
        a: '民事诉讼的立案判断标准不是以金额为准，是以我们的权益是否收到侵害，且我们有相应的证据证明我们的权益收到侵害为准。所以你需要先清楚你的权益收到了什么侵害，相应的法律依据是什么，并保存收集权益收到侵害的证据，如此即可去法院起诉立案。'
    },
    {
        q: '怎么起诉离婚，要准备什么手续，网上可以办理吗？',
        a: '离婚有两种方式，一种是协议离婚，一种是诉讼离婚，如不能协议离婚，就只能采取诉讼离婚的方式。诉讼离婚需要准备好起诉状，结婚证以及能够证明符合法定离婚事由的证据去婚姻登记地或被告所在地的法院起诉。可以在网上立案，但是开庭必须去现场开庭，否则会视为撤诉。'
    },
    {
        q: '定金可以退吗？我该怎么申请退还？要准备什么材料？',
        a: '定金是否能退还需要看我方申请退还定金的理由是否符合法定或约定的退还标准。若我方违约，定金是不能退还的，若对方违约，对方是应当退还双倍定金的。申请退还定金，需要准备好合同，定金支付凭证和对方违约的证据去法院发起起诉。'
    },
    {
        q: '父母的财产我该怎么继承？',
        a: '继承财产需要办理继承权公证，然后准备相应的公证文书、父母的死亡证明材料、亲属关系证明、遗嘱或遗产分配的公证文书向相应的遗产所在地如不动产权中心或遗产所在的银行去申请继承。'
    },
    {
        q: '公司没有缴纳社保，我该怎么办？',
        a: '缴纳社保是公司的法定义务，若你与公司建立了劳动关系，公司不依法缴纳社保，你可以向公司所在地的人社局进行投诉。'
    },
    {
        q: '公司拖欠工资，我该怎么办？',
        a: '公司拖欠工资的，你可以向公司所在地的劳动仲裁委申请劳动仲裁，向仲裁委提交公司拖欠工资的证据材料以及拖欠工资的具体金额，仲裁委会根据你提交的证据材料进行裁决。'
    },
    {
        q: '公司违法辞退我，我该怎么办？',
        a: '若被公司违法辞退可以向公司所在地的劳动仲裁委申请劳动仲裁，主张违法辞退的双倍赔偿。'
    },
    {
        q: '什么样的情形算醉驾？',
        a: '醉驾是指车辆驾驶人员血液中的酒精含量大于或者等于80mg/100ml的驾驶行为。'
    },
    {
        q: '什么样的情形算酒驾？',
        a: '酒驾是指车辆驾驶人员血液中的酒精含量大于或者于20mg/100ml，小于80mg/100ml的驾驶行为。'
    },
    {
        q: '我在工作期间受伤了算工伤吗？该怎么赔钱？',
        a: '若因为工作原因受伤属于工伤，用人单位可以在1个月内向人社局申请工伤认定，若用人单位没有在1个月内申请认定工伤，当事人或家属应当在一年内去申请工伤认定，认定工伤后可以向用人单位和人社局主张赔偿。'
    }
]
